var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4148 7.39062H9.35226V5.51562H11.4148V7.39062ZM11.4148 0.984375H9.35226V2.89062H11.4148V0.984375ZM13.8835 5.51562H11.821V7.39062H13.8835V5.51562ZM8.97726 3.26562H6.91476V5.14062H8.97726V3.26562ZM11.4148 3.26562H9.35226V5.14062H11.4148V3.26562ZM20.071 6.39062C19.6335 6.07812 18.6023 5.98438 17.7898 6.14062C17.696 5.39062 17.2585 4.73438 16.5085 4.14062L16.071 3.85938L15.7898 4.29688C15.196 5.17188 15.0398 6.57812 15.6648 7.54688C15.3835 7.67188 14.8523 7.89062 14.1648 7.85938H0.571008C0.289758 9.45312 0.758508 11.5156 1.94601 12.9219C3.10226 14.2969 4.85226 15.0156 7.10226 15.0156C12.0398 15.0156 15.6648 12.7344 17.3835 8.60938C18.0398 8.64062 19.4773 8.60938 20.2273 7.20312C20.2898 7.14062 20.446 6.79688 20.5085 6.67188L20.071 6.39062ZM4.10226 5.51562H2.03976V7.39062H4.10226V5.51562ZM6.53976 5.51562H4.47726V7.39062H6.53976V5.51562ZM8.97726 5.51562H6.91476V7.39062H8.97726V5.51562ZM6.53976 3.26562H4.47726V5.14062H6.53976V3.26562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerLogo);
export default __webpack_public_path__ + "static/media/docker-logo.15dcdad576f51d450d4e7e948e674200.svg";
export { ForwardRef as ReactComponent };